import { useCallback, useEffect, useState } from "react";
import { api } from "../../../utils/helpers";

export const devPdEdgeBase = (spaceId, instanceId) => `/api/cicd/transport/${encodeURIComponent(spaceId)}/${encodeURIComponent(instanceId)}/partner-directory/dev-edge-sync`;

// One readiness request per source, shared by every visible partner.
export default function useDevPdEdgeCapabilities(spaceId, instanceId, enabled) {
  const scope = enabled && spaceId && instanceId ? devPdEdgeBase(spaceId, instanceId) : "";
  const [requestedScope, setRequestedScope] = useState("");
  const key = scope && requestedScope === scope ? scope : "";
  const request = useCallback(() => setRequestedScope(scope), [scope]);
  const [generation, setGeneration] = useState(0);
  const [result, setResult] = useState({ key: "", loading: true });
  const reload = useCallback(() => setGeneration(value => value + 1), []);
  useEffect(() => {
    if (!key) return undefined;
    let active = true;
    const controller = new AbortController();
    setResult({ key, loading: true });
    api(`${key}/capabilities`, { cache: "no-store", signal: controller.signal, retry: false, timeout: 30000 }).then(value => {
      if (!value || typeof value.available !== "boolean" || !Array.isArray(value.targets)) throw new Error("EDGE_REQUEST_FAILED");
      if (active) setResult({ key, loading: false, value });
    }).catch(error => { if (active) setResult({ key, loading: false, error: error.code || "EDGE_REQUEST_FAILED" }); });
    return () => { active = false; controller.abort(); };
  }, [key, generation]);
  return { ...(key && result.key === key ? result : { loading: !!key }), idle: !key, request, reload };
}
